
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react'
import { MenuItem as ItemMenu } from "./MenuItem";
import { isRepresentante, shouldHideFeeDetails } from "../../libs/auth";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function MenuMobile({isOpen, onClose}: Props){
  const representanteOnly = isRepresentante();
  const hideFeeDetails = shouldHideFeeDetails();

  return (
    <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Menu</DrawerHeader>

          <DrawerBody display={'flex'} flexDir={'column'}>
            <ItemMenu title="Passagens" path="/home"/>
            {representanteOnly && <ItemMenu title="Agências afiliadas" path="/agencias-afiliadas" />}
            <ItemMenu title="Relatório" path="/relatorio"/>
            {!representanteOnly && !hideFeeDetails && <ItemMenu title="Faturas" path="/faturas" />}
            {!representanteOnly && !hideFeeDetails && <ItemMenu title="Usuários" path="/usuarios" />}
            {!representanteOnly && !hideFeeDetails && <ItemMenu title="Movimentação Financeira" path="/movimentacao" />}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
  )
}
